import moment from 'moment';

import fromAnyToBool from 'utils/converters/fromAnyToBool.util';

const isMoment = (any) => fromAnyToBool(any instanceof moment);

// noinspection JSUnusedGlobalSymbols
export default isMoment;
